var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTimer = function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 4.5h3.6v1.765h-3.6V4.5Zm-9 4.412h3.6v1.764H3.9V8.913Zm0 7.059h3.6v1.764H3.9v-1.764ZM3 12.44h3.591v1.765H3V12.44Zm17.736-4.67-1.272-1.248-1.537 1.506a6.338 6.338 0 0 0-3.227-.882c-3.473 0-6.3 2.772-6.3 6.176 0 3.405 2.827 6.177 6.3 6.177s6.3-2.771 6.3-6.177a6.083 6.083 0 0 0-1.67-4.173l1.406-1.38ZM15.6 14.206h-1.8V9.757h1.8v4.449Z"
  })));
};
export default SvgTimer;